import { StoreSelector } from "@faire/web--source/ui/hooks/ContextStore";

import {
  SelfServeContext,
  SelfServeNode,
  SelfServeNodeLevel,
  SelfServeNodeLevels,
} from "../types";
import { buildNodeLevelPropName } from "../utils/buildNodeLevelPropName";
import { setSelectedNodeToLocalStorage } from "../utils/localStorage";

import { useSelfServeContextStore } from "./SelfServeContext";

interface NodesSetters {
  setLevel0Node: (node: SelfServeNode) => void;
  setLevel1Node: (node: SelfServeNode) => void;
  setLevel2Node: (node: SelfServeNode) => void;
  setLevel3Node: (node: SelfServeNode) => void;
  setLevel4Node: (node: SelfServeNode) => void;
  setLevel5Node: (node: SelfServeNode) => void;
}

export const useNodeSetter = (): NodesSetters => {
  const [, setSelfServeContextStore] = useSelfServeContextStore([]);

  const setters: NodesSetters = {} as NodesSetters;

  for (const level of SelfServeNodeLevels) {
    const setterName = `setLevel${level}Node` as keyof NodesSetters;
    setters[setterName] = (node: SelfServeNode) => {
      const nodeLevelProp = buildNodeLevelPropName(level);
      const selectedNode = { [nodeLevelProp]: node };
      setSelectedNodeAndResetNodesAbove(
        level,
        setSelfServeContextStore,
        selectedNode
      );
      setSelectedNodeToLocalStorage(level, node.id);
    };
  }
  return setters;
};

export const setSelectedNodeAndResetNodesAbove = (
  level: SelfServeNodeLevel,
  setSelfServeContextStore: (selector: StoreSelector<SelfServeContext>) => void,
  selectedNode: Partial<SelfServeContext>
) => {
  let resetNodes = {} as SelfServeContext;
  for (
    let levelAbove = (level + 1) as SelfServeNodeLevel;
    levelAbove <= SelfServeNodeLevels.length;
    levelAbove++
  ) {
    const nodeLevelProp = buildNodeLevelPropName(levelAbove);
    resetNodes = { ...resetNodes, [nodeLevelProp]: undefined };
  }
  setSelfServeContextStore({ ...resetNodes, ...selectedNode });
};
